module.exports = __webpack_public_path__ + "static/img/blog_new_3.5df57ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_new_3.png
// module id = 9Klt
// module chunks = 8